import mCustomScrollbar from "malihu-custom-scrollbar-plugin";


( function ( $ ) {
	//console.log(themeData);
	const menuName = 'main_menu';

	var MainMenu = function(menuName) {
		this.menu = $( '#' + menuName );
	}

	const MMp = MainMenu.prototype;

	MMp.handleSubMenu = function(){
		const $lis = this.menu.find('li');
		const _self = this;

		$lis.each( function(){
			
			const 	$item = $(this),
					$ul = $item.children('ul'),
					$a = $item.children('a');
			
			if ( ! $ul.length ) return;

			var btn = document.createElement('button');
			btn.className = 'open-sub';
			btn.setAttribute('aria-label',themeData.strings['open-sub']);
			btn.innerHTML = `
							<span class="w100 h100 l-center open-sub-arrow">
								<i class="open-sub-arrow-icon arr-s-s l-svgspread">${new SvgIcons().render('arr-s-s',true)}</i>
							</span>`;
			btn.addEventListener('click', (e)=>{ e.preventDefault(); _self._openSub( $item, $ul )} );

			$a.html(`<span class="menu-link-text l-fg1-w0">${ $a.text() }</span>`);

			$a.append( btn );

		});
	};

	MMp._openSub = function( $item, $ul ){
		
		$item.toggleClass('is-sub-menu-shown');

		var effect = $ul.css('display',) === 'none' ? 'Down' : 'Up';

		$ul['slide' + effect](200);

	};
	
	MMp.allow_resize = true;

	MMp._setMenuPosition = function(){
		
		if ( ! this.allow_resize ) return;
		this.menu.css({
			top: lib.offset('#wpadminbar'),
			height: lib.viewport().height - lib.offset('#wpadminbar'),
		});
	};
	
	MMp.setMenuScrollBar = function(){
		
		if ( browser.mobile() ) return;
		
		this.menu.mCustomScrollbar({
			scrollEasing : 'linear',
			callbacks:{
				onCreate: ()=>{
					// remove close button from within scrollable div
					this.menu.children('.mCustomScrollBox').eq(0).after($('#close_main_menu'));
				}
			}			
		});

	};

	MMp.toggleMenuView = function(){

		$('#open_main_menu').on('click', ()=>{
			$('body').addClass('is-menu-open');
			this.allow_resize = true;
			this._setMenuPosition();
			window.addEventListener('resize',this._setMenuPosition.bind(this),true);
		});
		$('#close_main_menu').on('click', ()=>{
			$('body').removeClass('is-menu-open');
			this.allow_resize = false;
		});

	};

	MMp.swipeSupport = function(){

		$('#main_menu').swipe({
			swipeLeft : function(){
				if ( $('body').hasClass('rtl')) return;
				$('#close_main_menu').trigger('click');
			},
			swipeRight : function(){
				if ( ! $('body').hasClass('rtl')) return;
				$('#close_main_menu').trigger('click');
			}
		});
		
	};

	const newMenu = new MainMenu(menuName);

	newMenu.menu.length && lib.run_all( newMenu );

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/l-menu.js